{
    "national":[
        {
            "countryName": "India",
            "countryCode": "IN"
        },
        {
            "countryName": "United Kingdom",
            "countryCode": "GB"
        },
        {
            "countryName": "Philippines",
            "countryCode": "PH"
        },
        {
            "countryName": "USA",
            "countryCode": "US"
        },
        {
            "countryName": "Greece",
            "countryCode": "GR"
        },
        {
            "countryName": "Indonesia",
            "countryCode": "ID"
        },
        {
            "countryName": "Dominican Republic",
            "countryCode": "DO"
        },
        {
            "countryName": "Jamaica",
            "countryCode": "JM"
        },
        {
            "countryName": "Tanzania",
            "countryCode": "TZ"
        },
        {
            "countryName": "Cyprus",
            "countryCode": "CY"
        },
        {
            "countryName": "Spain",
            "countryCode": "ES"
        },
        {
            "countryName": "Portugal",
            "countryCode": "PT"
        },
        {
            "countryName": "Peru",
            "countryCode": "PE"
        },
        {
            "countryName": "Germany",
            "countryCode": "DE"
        },
        {
            "countryName": "Netherlands",
            "countryCode": "NL"
        },
        {
            "countryName": "Austria",
            "countryCode": "AT"
        },
        {
            "countryName": "Switzerland",
            "countryCode": "CH"
        },
        {
            "countryName": "Italy",
            "countryCode": "IT"
        },
        {
            "countryName": "Romania",
            "countryCode": "RO"
        },
        {
            "countryName": "Bulgaria",
            "countryCode": "BG"
        },
        {
            "countryName": "Guatemala",
            "countryCode": "GT"
        },
        {
            "countryName": "Turkey",
            "countryCode": "TR"
        },
        {
            "countryName": "Mexico",
            "countryCode": "MX"
        },
        {
            "countryName": "Chile",
            "countryCode": "CL"
        },
        {
            "countryName": "Czech Republic",
            "countryCode": "CZ"
        },
        {
            "countryName": "Denmark",
            "countryCode": "DK"
        },
        {
            "countryName": "Costa Rica",
            "countryCode": "CR"
        },
        {
            "countryName": "Paraguay",
            "countryCode": "PY"
        },
        {
            "countryName": "South Africa",
            "countryCode": "ZA"
        },
        {
            "countryName": "Iceland",
            "countryCode": "IS"
        },
        {
            "countryName": "Egypt",
            "countryCode": "EG"
        },
        {
            "countryName": "Uganda",
            "countryCode": "UG"
        },
        {
            "countryName": "Botswana",
            "countryCode": "BW"
        },
        {
            "countryName": "Saudi Arabia",
            "countryCode": "SA"
        },
        {
            "countryName": "Colombia",
            "countryCode": "CO"
        },
        {
            "countryName": "El Salvador",
            "countryCode": "SV"
        },
        {
            "countryName": "Maldives",
            "countryCode": "MV"
        },
        {
            "countryName": "France",
            "countryCode": "FR"
        },
        {
            "countryName": "Thailand",
            "countryCode": "TH"
        },
        {
            "countryName": "Uruguay",
            "countryCode": "UY"
        },
        {
            "countryName": "Kenya",
            "countryCode": "KE"
        },
        {
            "countryName": "Zambia",
            "countryCode": "ZM"
        },
        {
            "countryName": "United Arab Emirates",
            "countryCode": "AE"
        },
        {
            "countryName": "China",
            "countryCode": "CN"
        },
        {
            "countryName": "Viet Nam",
            "countryCode": "VN"
        },
        {
            "countryName": "Armenia",
            "countryCode": "AM"
        },
        {
            "countryName": "Malawi",
            "countryCode": "MW"
        },
        {
            "countryName": "Australia",
            "countryCode": "AU"
        },
        {
            "countryName": "Malaysia",
            "countryCode": "MY"
        },
        {
            "countryName": "Russian Federation",
            "countryCode": "RU"
        },
        {
            "countryName": "Hungary",
            "countryCode": "HU"
        },
        {
            "countryName": "Sweden",
            "countryCode": "SE"
        },
        {
            "countryName": "Montenegro",
            "countryCode": "ME"
        },
        {
            "countryName": "Argentina",
            "countryCode": "AR"
        },
        {
            "countryName": "Croatia",
            "countryCode": "HR"
        },
        {
            "countryName": "Finland",
            "countryCode": "FI"
        },
        {
            "countryName": "Ukraine",
            "countryCode": "UA"
        },
        {
            "countryName": "Slovenia",
            "countryCode": "SI"
        },
        {
            "countryName": "Belgium",
            "countryCode": "BE"
        },
        {
            "countryName": "Latvia",
            "countryCode": "LV"
        },
        {
            "countryName": "Reunion",
            "countryCode": "RE"
        },
        {
            "countryName": "Canada",
            "countryCode": "CA"
        },
        {
            "countryName": "Norway",
            "countryCode": "NO"
        },
        {
            "countryName": "Dominica",
            "countryCode": "DM"
        },
        {
            "countryName": "Senegal",
            "countryCode": "SN"
        },
        {
            "countryName": "Brazil",
            "countryCode": "BR"
        },
        {
            "countryName": "Mauritius",
            "countryCode": "MU"
        },
        {
            "countryName": "New Zealand",
            "countryCode": "NZ"
        },
        {
            "countryName": "Cambodia",
            "countryCode": "KH"
        },
        {
            "countryName": "Virgin Islands, U.S.",
            "countryCode": "VI"
        },
        {
            "countryName": "Japan",
            "countryCode": "JP"
        },
        {
            "countryName": "Eire / Ireland",
            "countryCode": "IE"
        },
        {
            "countryName": "Korea, Republic of",
            "countryCode": "KR"
        },
        {
            "countryName": "Sri Lanka",
            "countryCode": "LK"
        },
        {
            "countryName": "Slovakia",
            "countryCode": "SK"
        },
        {
            "countryName": "Ghana",
            "countryCode": "GH"
        },
        {
            "countryName": "Rwanda",
            "countryCode": "RW"
        },
        {
            "countryName": "Serbia",
            "countryCode": "RS"
        },
        {
            "countryName": "Nigeria",
            "countryCode": "NG"
        },
        {
            "countryName": "Albania",
            "countryCode": "AL"
        },
        {
            "countryName": "Bahamas",
            "countryCode": "BS"
        },
        {
            "countryName": "Grenada",
            "countryCode": "GD"
        },
        {
            "countryName": "Cuba",
            "countryCode": "CU"
        },
        {
            "countryName": "Malta",
            "countryCode": "MT"
        },
        {
            "countryName": "Seychelles",
            "countryCode": "SC"
        },
        {
            "countryName": "Saint Lucia",
            "countryCode": "LC"
        },
        {
            "countryName": "Trinidad and Tobago",
            "countryCode": "TT"
        },
        {
            "countryName": "Tunisia",
            "countryCode": "TN"
        },
        {
            "countryName": "Honduras",
            "countryCode": "HN"
        },
        {
            "countryName": "Cape Verde",
            "countryCode": "CV"
        },
        {
            "countryName": "Martinique",
            "countryCode": "MQ"
        },
        {
            "countryName": "Poland",
            "countryCode": "PL"
        },
        {
            "countryName": "Guadeloupe",
            "countryCode": "GP"
        },
        {
            "countryName": "Jordan",
            "countryCode": "JO"
        },
        {
            "countryName": "Myanmar",
            "countryCode": "MM"
        },
        {
            "countryName": "Bonaire, Sint Eustatius and Saba",
            "countryCode": "BQ"
        },
        {
            "countryName": "French Polynesia",
            "countryCode": "PF"
        },
        {
            "countryName": "Cayman Islands",
            "countryCode": "KY"
        },
        {
            "countryName": "Barbados",
            "countryCode": "BB"
        },
        {
            "countryName": "Bolivia",
            "countryCode": "BO"
        },
        {
            "countryName": "Venezuela",
            "countryCode": "VE"
        },
        {
            "countryName": "Namibia",
            "countryCode": "NA"
        },
        {
            "countryName": "Guam",
            "countryCode": "GU"
        },
        {
            "countryName": "Cook Islands",
            "countryCode": "CK"
        },
        {
            "countryName": "Congo, Democratic Republic (ex. Zaire)",
            "countryCode": "CD"
        },
        {
            "countryName": "Togo",
            "countryCode": "TG"
        },
        {
            "countryName": "Chad",
            "countryCode": "TD"
        },
        {
            "countryName": "Madagascar",
            "countryCode": "MG"
        },
        {
            "countryName": "Taiwan, Province of China",
            "countryCode": "TW"
        },
        {
            "countryName": "Mozambique",
            "countryCode": "MZ"
        },
        {
            "countryName": "Palestine",
            "countryCode": "PS"
        },
        {
            "countryName": "Palau",
            "countryCode": "PW"
        },
        {
            "countryName": "Bosnia and Herzigovina",
            "countryCode": "BA"
        },
        {
            "countryName": "Luxembourg",
            "countryCode": "LU"
        },
        {
            "countryName": "Mayotte",
            "countryCode": "YT"
        },
        {
            "countryName": "Zimbabwe",
            "countryCode": "ZW"
        },
        {
            "countryName": "Estland",
            "countryCode": "EE"
        },
        {
            "countryName": "Belarus",
            "countryCode": "BY"
        },
        {
            "countryName": "Anguilla",
            "countryCode": "AI"
        },
        {
            "countryName": "Israel",
            "countryCode": "IL"
        },
        {
            "countryName": "Andorra",
            "countryCode": "AD"
        },
        {
            "countryName": "Georgia",
            "countryCode": "GE"
        },
        {
            "countryName": "Vanuatu",
            "countryCode": "VU"
        },
        {
            "countryName": "Panama",
            "countryCode": "PA"
        },
        {
            "countryName": "Fiji",
            "countryCode": "FJ"
        },
        {
            "countryName": "Ethiopia",
            "countryCode": "ET"
        },
        {
            "countryName": "Belize",
            "countryCode": "BZ"
        },
        {
            "countryName": "Macedonia (FYROM)",
            "countryCode": "MK"
        },
        {
            "countryName": "Puerto Rico",
            "countryCode": "PR"
        },
        {
            "countryName": "Oman",
            "countryCode": "OM"
        },
        {
            "countryName": "Nepal",
            "countryCode": "NP"
        },
        {
            "countryName": "Bhutan",
            "countryCode": "BT"
        },
        {
            "countryName": "Pakistan",
            "countryCode": "PK"
        },
        {
            "countryName": "Qatar",
            "countryCode": "QA"
        },
        {
            "countryName": "Aserbaidshan",
            "countryCode": "AZ"
        },
        {
            "countryName": "Kazakstan",
            "countryCode": "KZ"
        },
        {
            "countryName": "Curaçao",
            "countryCode": "CW"
        },
        {
            "countryName": "Ecuador",
            "countryCode": "EC"
        },
        {
            "countryName": "San Marino",
            "countryCode": "SM"
        },
        {
            "countryName": "Nicaragua",
            "countryCode": "NI"
        },
        {
            "countryName": "Bangladesh",
            "countryCode": "BD"
        },
        {
            "countryName": "Lithuania",
            "countryCode": "LT"
        },
        {
            "countryName": "Eritrea",
            "countryCode": "ER"
        },
        {
            "countryName": "Congo",
            "countryCode": "CG"
        },
        {
            "countryName": "Angola",
            "countryCode": "AO"
        },
        {
            "countryName": "Sierra Leone",
            "countryCode": "SL"
        },
        {
            "countryName": "Samoa",
            "countryCode": "WS"
        },
        {
            "countryName": "Morocco",
            "countryCode": "MA"
        },
        {
            "countryName": "Virgin Islands, British",
            "countryCode": "VG"
        },
        {
            "countryName": "Lao People's Democratic Republic",
            "countryCode": "LA"
        },
        {
            "countryName": "Algeria",
            "countryCode": "DZ"
        },
        {
            "countryName": "Sudan",
            "countryCode": "SD"
        },
        {
            "countryName": "Uzbekistan",
            "countryCode": "UZ"
        },
        {
            "countryName": "Kyrgystan",
            "countryCode": "KG"
        },
        {
            "countryName": "Moldova",
            "countryCode": "MD"
        },
        {
            "countryName": "Iraq",
            "countryCode": "IQ"
        },
        {
            "countryName": "Haiti",
            "countryCode": "HT"
        },
        {
            "countryName": "Lebanon",
            "countryCode": "LB"
        },
        {
            "countryName": "New Caledonia",
            "countryCode": "NC"
        },
        {
            "countryName": "Monaco",
            "countryCode": "MC"
        },
        {
            "countryName": "Kuwait",
            "countryCode": "KW"
        },
        {
            "countryName": "St. Kitts and Nevis",
            "countryCode": "KN"
        },
        {
            "countryName": "Turks and Caicos Islands",
            "countryCode": "TC"
        },
        {
            "countryName": "Norfolk Island",
            "countryCode": "NF"
        },
        {
            "countryName": "Singapore",
            "countryCode": "SG"
        },
        {
            "countryName": "Sao Tome and Principe",
            "countryCode": "ST"
        },
        {
            "countryName": "Brunei Darussalam",
            "countryCode": "BN"
        },
        {
            "countryName": "Hong Kong",
            "countryCode": "HK"
        },
        {
            "countryName": "Benin",
            "countryCode": "BJ"
        },
        {
            "countryName": "Lesotho",
            "countryCode": "LS"
        },
        {
            "countryName": "Gambia",
            "countryCode": "GM"
        },
        {
            "countryName": "Macau",
            "countryCode": "MO"
        },
        {
            "countryName": "Bermuda",
            "countryCode": "BM"
        },
        {
            "countryName": "Saint-Martin",
            "countryCode": "MF"
        },
        {
            "countryName": "Gibraltar",
            "countryCode": "GI"
        },
        {
            "countryName": "Ivory Coast",
            "countryCode": "CI"
        },
        {
            "countryName": "Bahrain",
            "countryCode": "BH"
        },
        {
            "countryName": "Aruba",
            "countryCode": "AW"
        },
        {
            "countryName": "Tonga",
            "countryCode": "TO"
        },
        {
            "countryName": "Antigua and Barbuda",
            "countryCode": "AG"
        },
        {
            "countryName": "Kingdom of Eswatini",
            "countryCode": "SZ"
        },
        {
            "countryName": "Liechtenstein",
            "countryCode": "LI"
        },
        {
            "countryName": "Saint Vincent and the Grenadines",
            "countryCode": "VC"
        },
        {
            "countryName": "Saint-Barthélemy",
            "countryCode": "BL"
        },
        {
            "countryName": "Syrian Arab Republic",
            "countryCode": "SY"
        },
        {
            "countryName": "Yemen",
            "countryCode": "YE"
        },
        {
            "countryName": "Iran",
            "countryCode": "IR"
        },
        {
            "countryName": "Mongolia",
            "countryCode": "MN"
        },
        {
            "countryName": "Faeroe Islands",
            "countryCode": "FO"
        },
        {
            "countryName": "Papua New Guinea",
            "countryCode": "PG"
        },
        {
            "countryName": "Other Countries",
            "countryCode": "XO"
        },
        {
            "countryName": "Greenland",
            "countryCode": "GL"
        },
        {
            "countryName": "Sint Maarten",
            "countryCode": "SX"
        },
        {
            "countryName": "Northern Mariana Islands",
            "countryCode": "MP"
        },
        {
            "countryName": "Afghanistan",
            "countryCode": "AF"
        },
        {
            "countryName": "Guyana",
            "countryCode": "GY"
        },
        {
            "countryName": "Cameroon",
            "countryCode": "CM"
        },
        {
            "countryName": "Mali",
            "countryCode": "ML"
        },
        {
            "countryName": "Burundi",
            "countryCode": "BI"
        },
        {
            "countryName": "French Guiana",
            "countryCode": "GF"
        },
        {
            "countryName": "Libya",
            "countryCode": "LY"
        },
        {
            "countryName": "Guinea",
            "countryCode": "GN"
        },
        {
            "countryName": "Federated States of Micronesia",
            "countryCode": "FM"
        },
        {
            "countryName": "Djibouti",
            "countryCode": "DJ"
        },
        {
            "countryName": "Comoros",
            "countryCode": "KM"
        },
        {
            "countryName": "Suriname",
            "countryCode": "SR"
        },
        {
            "countryName": "Niger",
            "countryCode": "NE"
        },
        {
            "countryName": "Mauritania",
            "countryCode": "MR"
        },
        {
            "countryName": "Turkmenistan",
            "countryCode": "TM"
        },
        {
            "countryName": "Gabon",
            "countryCode": "GA"
        },
        {
            "countryName": "Burkina Faso",
            "countryCode": "BF"
        },
        {
            "countryName": "Somalia",
            "countryCode": "SO"
        },
        {
            "countryName": "South Sudan",
            "countryCode": "SS"
        },
        {
            "countryName": "St. Helena",
            "countryCode": "SH"
        },
        {
            "countryName": "Liberia",
            "countryCode": "LR"
        },
        {
            "countryName": "Central African Republic",
            "countryCode": "CF"
        },
        {
            "countryName": "American Samoa",
            "countryCode": "AS"
        },
        {
            "countryName": "East Timor",
            "countryCode": "TL"
        },
        {
            "countryName": "Solomon Islands",
            "countryCode": "SB"
        },
        {
            "countryName": "Tajikistan",
            "countryCode": "TJ"
        },
        {
            "countryName": "Guinea-Bissau",
            "countryCode": "GW"
        },
        {
            "countryName": "Kosovo",
            "countryCode": "XK"
        },
        {
            "countryName": "Western Sahara",
            "countryCode": "EH"
        },
        {
            "countryName": "Cocos (Keeling) Islands",
            "countryCode": "CC"
        },
        {
            "countryName": "Niue",
            "countryCode": "NU"
        },
        {
            "countryName": "Equatorial Guinea",
            "countryCode": "GQ"
        },
        {
            "countryName": "Kiribati",
            "countryCode": "KI"
        },
        {
            "countryName": "Falkland Islands",
            "countryCode": "FK"
        },
        {
            "countryName": "St. Pierre and Miquelon",
            "countryCode": "PM"
        },
        {
            "countryName": "Nauru",
            "countryCode": "NR"
        },
        {
            "countryName": "Montserrat",
            "countryCode": "MS"
        },
        {
            "countryName": "Wallis and Futuna Islands",
            "countryCode": "WF"
        }
    ]
}